import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { ActionItemView } from '@ndvr/customer-api';

import { CustomerApi } from 'API';

export const ActionItemQueryKeys = {
    actionItemsByNote: (noteGUID: string) => ['ActionItems', noteGUID] as const,
} as const;

// Endpoint plus the by-note query it makes stale, so every dismiss caller invalidates the same key.
export const actionItemDismissal = (actionItemGUID: string, noteGUID: string) => ({
    request: () => CustomerApi().dismissActionItem(actionItemGUID),
    staleQueryKey: ActionItemQueryKeys.actionItemsByNote(noteGUID),
});

export const useActionItemsByNoteQuery = <TData = ActionItemView[]>(
    noteGUID: string,
    options?: { select?: (actionItems: ActionItemView[]) => TData },
) =>
    useQuery<ActionItemView[], Error, TData>({
        enabled: !!noteGUID,
        queryKey: ActionItemQueryKeys.actionItemsByNote(noteGUID),
        queryFn: async () => {
            const [response] = await CustomerApi().getActionItemsByNoteGUID({ noteGUID });
            return response ?? [];
        },
        ...options,
    });

export const useDismissActionItemMutation = (noteGUID: string) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (actionItemGUID: string) => actionItemDismissal(actionItemGUID, noteGUID).request(),
        onSuccess: (_, actionItemGUID) => {
            queryClient.invalidateQueries({ queryKey: actionItemDismissal(actionItemGUID, noteGUID).staleQueryKey });
        },
    });
};
